export const Reveal = ({ children, delay = 0, className = "" }) => (
  <div
    data-rv=""
    style={delay ? { transitionDelay: `${delay}s` } : undefined}
    className={className}
  >
    {children}
  </div>
);

export const MaskLine = ({ children, delay = 0, className = "" }) => (
  <span className="block overflow-hidden">
    <span
      data-rv=""
      data-rv-mask=""
      style={delay ? { transitionDelay: `${delay}s` } : undefined}
      className={`block ${className}`}
    >
      {children}
    </span>
  </span>
);

export const SectionLabel = ({ children, testId }) => (
  <Reveal>
    <div className="flex items-center gap-4" data-testid={testId}>
      <span className="h-px w-10" style={{ background: "var(--brass)" }} />
      <span className="label">{children}</span>
    </div>
  </Reveal>
);
